import axios from 'axios'
import { cautionUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 查询告警信息
export function getCautionList(params) {
  const url = cautionUrl + '/alert/pageAlertMsg'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '查询告警信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询告警类型
export function findAlertType(params) {
  const url = cautionUrl + '/alert/findAlertType'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '查询告警类型', res)
    }
    return Promise.resolve(res.data)
  })
}

// 修改告警状态
export function updateStatus(params) {
  const url = cautionUrl + '/alert/updateStatus'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '修改告警状态', res)
    }
    return Promise.resolve(res.data)
  })
}

// 修改告警状态
export function clearMessage() {
  const url = cautionUrl + '/alert/clear/message'

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '一键处理告警信息', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 导出设备列表
 */
export function exportAlert(params) {
  return axios({
    method: 'post',
    url: `${cautionUrl}/alert/export`,
    data: params,
    responseType: 'blob',
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
